module.exports = __webpack_public_path__ + "img/mp.03b166e.svg";